import { gsap, ScrollTrigger } from '../global/gsap';

const initEventHero = (section) => {
    section.forEach(section => {
        const mobileStickySection = section.nextElementSibling;
        const endSection = document.querySelector('.js-event-tickets');

        if(mobileStickySection && mobileStickySection.classList.contains('js-mobile-booking')) {
            
            const tl = gsap.timeline({
                scrollTrigger: {
                    trigger: mobileStickySection,
                    start: 'bottom bottom',
                    onEnter: () => {
                        mobileStickySection.classList.add('is-sticky')
                    },
                    onLeaveBack: () => {
                        mobileStickySection.classList.remove('is-sticky')
                    },
                }
            })

            const hideTl = gsap.timeline({
                scrollTrigger : {
                    trigger: endSection,
                    start: 'top bottom',
                    onEnter: () => {
                        mobileStickySection.classList.add('is-hidden')
                    },
                    onLeaveBack: () => {
                        mobileStickySection.classList.remove('is-hidden')
                    },
                }
            })

        }
    })
}

export default initEventHero;